<script setup lang="ts">
definePageMeta({
  layout: 'front-page',
  public: true,
  pageTitle: {
    title: 'Privacy & GDPR',
    subtitle: 'Hoe wij omgaan met uw persoonsgegevens in overeenstemming met de AVG/GDPR',
    icon: 'bx-shield-quarter',
    iconColor: 'primary',
  },
})

const sections = [
  {
    title: '1. Inleiding',
    content: 'Deze Privacyverklaring beschrijft hoe wij omgaan met persoonsgegevens in overeenstemming met de Algemene Verordening Gegevensbescherming (AVG/GDPR). Wij respecteren uw privacy en zorgen ervoor dat persoonlijke informatie die u ons verstrekt vertrouwelijk wordt behandeld.',
  },
  {
    title: '2. Verantwoordelijke voor de gegevensverwerking',
    content: `'t SpeelFabrik VZW
Langestraat 15b
1910 Kampenhout
contact@tspeelfabrik.be
+32 474 68 10 52
KBO: 1030.185.629`,
  },
  {
    title: '3. Welke persoonsgegevens verwerken wij?',
    content: `Wij verwerken de volgende persoonsgegevens:

Van de ouder/voogd:
• Voor- en achternaam
• E-mailadres
• Telefoonnummer
• Adresgegevens

Van de deelnemer (kind/jongere):
• Voor- en achternaam
• Geboortedatum
• Geslacht
• Medische informatie (allergieën, medicijngebruik, aandachtspunten)
• Foto's en video's gemaakt tijdens kampen (met toestemming)

Technische gegevens:
• IP-adres
• Cookies (zie ons Cookie Policy)`,
  },
  {
    title: '4. Waarom verwerken wij persoonsgegevens?',
    content: `Wij verwerken uw persoonsgegevens voor de volgende doeleinden:
• Het verwerken en beheren van kampinschrijvingen
• Het waarborgen van de veiligheid en gezondheid van deelnemers tijdens kampen
• Het verwerken van betalingen
• Het communiceren over praktische kampzaken (locatie, tijden, programma)
• Het verzenden van nieuwsbrieven over toekomstige kampen (indien toestemming gegeven)
• Het verbeteren van onze kampen en website
• Het voldoen aan wettelijke verplichtingen (o.a. fiscaal, verzekeringen)`,
  },
  {
    title: '5. Rechtsgronden voor gegevensverwerking',
    content: `Wij verwerken uw persoonsgegevens op basis van:
• Toestemming: U heeft uitdrukkelijk toestemming gegeven voor de verwerking
• Contractuele noodzaak: De verwerking is noodzakelijk voor het uitvoeren van een overeenkomst
• Wettelijke verplichting: Wij zijn wettelijk verplicht bepaalde gegevens te verwerken
• Gerechtvaardigd belang: De verwerking is noodzakelijk voor onze gerechtvaardigde belangen`,
  },
  {
    title: '6. Bewaartermijnen',
    content: `Wij bewaren uw persoonsgegevens niet langer dan noodzakelijk:
• Inschrijvings- en betalingsgegevens: 7 jaar na het kamp (wettelijke bewaarplicht)
• Medische gegevens van deelnemers: Tot 1 jaar na het kamp, daarna verwijderd
• Accountgegevens: Tot u uw account verwijdert
• Foto's en video's: Maximaal 2 jaar, tenzij u toestemming geeft voor langer gebruik
• Nieuwsbriefvoorkeuren: Tot u uw toestemming intrekt
• Logbestanden en IP-adressen: Maximaal 12 maanden`,
  },
  {
    title: '7. Uw rechten onder de AVG/GDPR',
    content: `U heeft de volgende rechten met betrekking tot uw persoonsgegevens:
• Recht op inzage: U kunt opvragen welke gegevens wij van u verwerken
• Recht op rectificatie: U kunt onjuiste gegevens laten corrigeren
• Recht op verwijdering ('recht om vergeten te worden'): U kunt verzoeken uw gegevens te verwijderen
• Recht op beperking: U kunt verzoeken de verwerking te beperken
• Recht op dataportabiliteit: U kunt uw gegevens in een gestructureerd formaat ontvangen
• Recht van bezwaar: U kunt bezwaar maken tegen bepaalde verwerkingen
• Recht om toestemming in te trekken: Als verwerking op toestemming is gebaseerd

Om deze rechten uit te oefenen, kunt u contact met ons opnemen via contact@tspeelfabrik.be.`,
  },
  {
    title: '8. Gegevens delen met derden',
    content: `Wij delen uw persoonsgegevens alleen met derden wanneer dit noodzakelijk is:
• Hosting: Vercel (Frankfurt, Duitsland) - Website hosting
• Database & Authenticatie: Supabase (Frankfurt, Duitsland) - Gegevensopslag en gebruikersauthenticatie
• Betalingsverwerking: Stripe (EU) - Veilige betalingsafhandeling
• E-mailverzending: Brevo (Frankrijk) - Transactionele e-mails
• Analytics: Umami (EU, Cloud) - Privacy-vriendelijke website statistieken (geen tracking cookies)
• Wettelijke verplichtingen: Wanneer wij wettelijk verplicht zijn gegevens te delen

Al deze dienstverleners zijn gevestigd binnen de EU/EER en onze verwerkersovereenkomsten voldoen aan de AVG-vereisten. Wij gebruiken geen Google Analytics, Facebook tracking of andere tracking-diensten die persoonsgegevens doorsturen naar de VS.`,
  },
  {
    title: '9. Internationale gegevensoverdrachten',
    content: `Indien wij persoonsgegevens overdragen naar landen buiten de Europese Economische Ruimte (EER), zorgen wij voor passende waarborgen zoals:
• Standaard Contractuele Clausules van de Europese Commissie
• Adequaatheidsbesluit van de Europese Commissie
• Privacy Shield certificering (waar van toepassing)`,
  },
  {
    title: '10. Beveiliging',
    content: `Wij nemen passende technische en organisatorische maatregelen om uw persoonsgegevens te beschermen tegen verlies, misbruik, ongeautoriseerde toegang en openbaarmaking:
• SSL/TLS encryptie voor alle datatransmissies
• Regelmatige security audits en updates
• Toegangscontrole en authenticatie
• Encryptie van opgeslagen gegevens
• Back-up procedures
• Bewustzijnstrainingen voor medewerkers`,
  },
  {
    title: '11. Cookies',
    content: 'Onze website maakt gebruik van cookies. Voor meer informatie over welke cookies wij gebruiken en hoe u deze kunt beheren, verwijzen wij u naar ons Cookie Policy.',
  },
  {
    title: '12. Wijzigingen in deze privacyverklaring',
    content: `Wij behouden ons het recht voor deze privacyverklaring te wijzigen. De meest recente versie is altijd beschikbaar op onze website. De laatste wijziging was op ${new Date().toLocaleDateString('nl-BE')}.`,
  },
  {
    title: '13. Klachten',
    content: `Als u niet tevreden bent over hoe wij met uw persoonsgegevens omgaan, kunt u een klacht indienen bij de Belgische Gegevensbeschermingsautoriteit (GBA):

Gegevensbeschermingsautoriteit
Drukpersstraat 35
1000 Brussel
Tel: +32 2 274 48 00
E-mail: contact@apd-gba.be
Website: www.gegevensbeschermingsautoriteit.be`,
  },
  {
    title: '14. Contact',
    content: `Voor vragen over deze privacyverklaring of over hoe wij met uw persoonsgegevens omgaan, kunt u contact met ons opnemen:

't SpeelFabrik VZW
E-mail: contact@tspeelfabrik.be
Telefoon: +32 474 68 10 52
Adres: Langestraat 15b, 1910 Kampenhout`,
  },
]
</script>

<template>
  <VContainer>
    <VCard
      class="pa-4 pt-7"
      max-width="1200"
      style="margin-block: 0;margin-inline: auto;"
    >
      <VCardText class="pt-2">
        <VContainer>
          <div
            v-for="(section, index) in sections"
            :key="index"
            class="mb-6"
          >
            <h2 class="text-h6 mb-3">
              {{ section.title }}
            </h2>
            <p
              class="text-body-1"
              style="white-space: pre-line;"
            >
              {{ section.content }}
            </p>
          </div>

          <VDivider class="my-6" />

          <div class="text-center">
            <VBtn
              to="/"
              color="primary"
            >
              Terug naar Home
            </VBtn>
          </div>
        </VContainer>
      </VCardText>
    </VCard>
  </VContainer>
</template>
